export default __webpack_public_path__ + "static/winter39-7d1c2d71370591441e881f567e5535ab.webp";